import { styled } from '@mui/material';
import { forwardRef } from 'react';
import {
    Add,
    Announcement,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    Attach,
    Avatar,
    Bell,
    Bold,
    BookmarkFilled,
    BookmarkOutlined,
    Calendar,
    Call,
    CallDisabled,
    CallIncoming,
    CallOutgoing,
    Canada,
    Channel,
    Checkmark,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Clock,
    Code,
    Copy,
    Dashboard,
    Delete,
    Download,
    DropdownArrowDown,
    DropdownArrowUp,
    Edit,
    Email,
    Ensightful,
    Error as ErrorIcon,
    Exit,
    FavoriteEmpty,
    FavoriteFilled,
    FileCSV,
    FileExcel,
    FileImg,
    FilePDF,
    FilePPT,
    FileTypeDoc,
    FileTypeGif,
    FileTypeJpg,
    FileTypePdf,
    FileTypePng,
    FileTypeSvg,
    FileTypeTxt,
    FileTypeUndefined,
    FileTypeVideo,
    FileTypeZip,
    FileUnknown,
    FileUploaded,
    FileWord,
    FileZIP,
    Filter,
    Folder,
    FormatDeselected,
    FormatSelected,
    FullScreenEnter,
    FullScreenExit,
    Google,
    GraphBarEmpty,
    GraphPieEmpty,
    GraphPieFilled,
    Hamburger,
    Hashtag,
    Help,
    Hide,
    Home,
    Info,
    Italic,
    Link,
    ListOrdered,
    ListUnordered,
    LocationEmpty,
    LocationFilled,
    Lock,
    Logout,
    Message,
    MessageFilled,
    MessageRectangular,
    Mic,
    MoreHorizontal,
    PageJumpLeft,
    PageJumpRight,
    Photo,
    Preview,
    Randomize,
    Refresh,
    Remove,
    Reorder,
    Reply,
    Resync,
    Rocket,
    Save,
    Search,
    Send,
    Settings,
    Smile,
    Sort,
    SoundMuted,
    StarEmpty,
    StarFilled,
    StopWatch,
    Subtask,
    Task,
    TaskBoard,
    Teams,
    TextAlignLeft,
    TextAlignRight,
    ThumbsDown,
    ThumbsUp,
    Timeline,
    USA,
    Underline,
    Unlock,
    Upload,
    Video,
    Visible,
    Web,
    ZoomIn,
    ZoomOut,
} from 'shell/icons';

const icons = {
    add: Add,
    announcement: Announcement,
    arrowDown: ArrowDown,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    arrowUp: ArrowUp,
    attach: Attach,
    avatar: Avatar,
    bell: Bell,
    bold: Bold,
    bookmarkFilled: BookmarkFilled,
    bookmarkOutlined: BookmarkOutlined,
    calendar: Calendar,
    call: Call,
    callDisabled: CallDisabled,
    callIncoming: CallIncoming,
    callOutgoing: CallOutgoing,
    canada: Canada,
    channel: Channel,
    checkmark: Checkmark,
    chevronDown: ChevronDown,
    chevronLeft: ChevronLeft,
    chevronRight: ChevronRight,
    chevronUp: ChevronUp,
    clock: Clock,
    code: Code,
    copy: Copy,
    dashboard: Dashboard,
    delete: Delete,
    download: Download,
    dropdownArrowDown: DropdownArrowDown,
    dropdownArrowUp: DropdownArrowUp,
    edit: Edit,
    email: Email,
    ensightful: Ensightful,
    error: ErrorIcon,
    exit: Exit,
    favoriteEmpty: FavoriteEmpty,
    favoriteFilled: FavoriteFilled,
    fileCSV: FileCSV,
    fileExcel: FileExcel,
    fileImg: FileImg,
    filePDF: FilePDF,
    filePPT: FilePPT,
    fileTypeDoc: FileTypeDoc,
    fileTypeGif: FileTypeGif,
    fileTypeJpg: FileTypeJpg,
    fileTypePdf: FileTypePdf,
    fileTypePng: FileTypePng,
    fileTypeSvg: FileTypeSvg,
    fileTypeTxt: FileTypeTxt,
    fileTypeUndefined: FileTypeUndefined,
    fileTypeVideo: FileTypeVideo,
    fileTypeZip: FileTypeZip,
    fileUnknown: FileUnknown,
    fileUploaded: FileUploaded,
    fileWord: FileWord,
    fileZIP: FileZIP,
    filter: Filter,
    folder: Folder,
    formatSelected: FormatSelected,
    formatDeselected: FormatDeselected,
    fullScreenEnter: FullScreenEnter,
    fullScreenExit: FullScreenExit,
    google: Google,
    graphBarEmpty: GraphBarEmpty,
    graphPieEmpty: GraphPieEmpty,
    graphPieFilled: GraphPieFilled,
    hamburger: Hamburger,
    hashtag: Hashtag,
    help: Help,
    hide: Hide,
    home: Home,
    info: Info,
    italic: Italic,
    link: Link,
    listOrdered: ListOrdered,
    listUnordered: ListUnordered,
    locationEmpty: LocationEmpty,
    locationFilled: LocationFilled,
    lock: Lock,
    logout: Logout,
    message: Message,
    messageFilled: MessageFilled,
    messageRectangular: MessageRectangular,
    mic: Mic,
    moreHorizontal: MoreHorizontal,
    pageJumpLeft: PageJumpLeft,
    pageJumpRight: PageJumpRight,
    photo: Photo,
    preview: Preview,
    randomize: Randomize,
    refresh: Refresh,
    remove: Remove,
    reorder: Reorder,
    reply: Reply,
    resync: Resync,
    rocket: Rocket,
    save: Save,
    search: Search,
    send: Send,
    settings: Settings,
    smile: Smile,
    sort: Sort,
    soundMuted: SoundMuted,
    starEmpty: StarEmpty,
    starFilled: StarFilled,
    stopWatch: StopWatch,
    subtask: Subtask,
    task: Task,
    taskBoard: TaskBoard,
    teams: Teams,
    textAlignLeft: TextAlignLeft,
    textAlignRight: TextAlignRight,
    thumbsDown: ThumbsDown,
    thumbsUp: ThumbsUp,
    timeline: Timeline,
    underline: Underline,
    unlock: Unlock,
    upload: Upload,
    usa: USA,
    video: Video,
    visible: Visible,
    web: Web,
    zoomIn: ZoomIn,
    zoomOut: ZoomOut,
};

const KINDS = Object.keys(icons);

const Icon = forwardRef(({ kind, ...rest }, ref) => {
    const IconComponent = icons[kind];
    return <IconComponent ref={ref} {...rest} />;
});

const CustomIcon = styled(Icon)(() => {
    return {
        fontSize: '0.75rem',
    };
});

export default forwardRef((props, ref) => {
    if (!KINDS.includes(props.kind)) throw new Error(`Shell: Invalid kind "${props.kind}" in component Icon.`);

    return <CustomIcon ref={ref} {...props} />;
});
